import { render } from "./ProximityResults.vue?vue&type=template&id=f407a13a&scoped=true&lang=pug"
import script from "./ProximityResults.vue?vue&type=script&lang=js"
export * from "./ProximityResults.vue?vue&type=script&lang=js"

import "./ProximityResults.vue?vue&type=style&index=0&id=f407a13a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f407a13a"]])

export default __exports__